import { connect } from 'react-redux'
import { RootState } from '@store/store'
import {
  getTimeline,
  timelineMarkersListSelector,
  timelineTimespansListSelector,
} from '@selectors/data/timeline_selectors'
import { getPhotos } from '@selectors/data/photo_selectors'
import HorizontalTimeline from '../components/HorizontalTimeline'

// This container is used to fetch timeline data, stored in the legacy format, and provide it to the timeline component.

const mapStateToProps = (state: RootState, props: any) => {
  const timeline = getTimeline(state, props)
  const markers = timelineMarkersListSelector(state, props)
  const timespans = timelineTimespansListSelector(state, props)
  const photos = getPhotos(state)
  return {
    ...props,
    timeline,
    markers,
    timespans,
    photos,
  }
}

const mapDispatchToProps = (_dispatch: any, _props: any) => {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(HorizontalTimeline)
